import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import Input from '../../form/input/input.jsx'
import Select from '../../form/select/select.jsx'
import UploadAvatar from '../../form/upload_avatar/upload_avatar.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'
import Button from '../../common/button/button.jsx'
import Typo from '../../typography/typo/typo.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'
import DateUtil from '../../../lib/dateutil.jsx'

class UserProfileForm extends Component {
  constructor (props) {
    super(props)

    this.state = {
      dataDate: null,
      imageAvatar: null,
      imageAvatarUrl: null,
      imageDeleted: false
    }

    this.data = {
      languages: [
        { label: 'user.profile.optionNederlands', value: 'NL' },
        { label: 'user.profile.optionEnglish', value: 'EN' },
        { label: 'user.profile.optionDeutsch', value: 'DE' }
      ],
      user: _.cloneDeep(this.props.user)
    }

    this._references = {
      inputFirstName: React.createRef(),
      inputLastName: React.createRef()
    }
  }

  static get propTypes () {
    return {
      user: PropTypes.object,
      onSubmit: PropTypes.func,
      onError: PropTypes.func,
      onClickChangePassword: PropTypes.func,
      showLanguageDropdown: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      user: null,
      onSubmit: null,
      onError: null,
      onClickChangePassword: null,
      showLanguageDropdown: true
    }
  }

  render () {
    const user = this.data.user
    const imageUrl = this.state.imageAvatar
      ? this.state.imageAvatarUrl
      : user.imageUrl

    return (
      <form
        className='form'
        method='post'
        noValidate
        action='#'
        onSubmit={this._onFormSubmit.bind(this)}
      >
        <div className='userprofile-form'>
          <div className='col colleft'>
            <div className='introblock'>
              <Typo className='profile'>
                <h2>
                  <IntlMessage ident='user.profile.contentTitle' />
                </h2>
                <p>
                  <IntlMessage ident='user.profile.contentInfo' />
                </p>
              </Typo>
              <UploadAvatar
                image={imageUrl}
                className='userprofile-upload'
                defaultImage='/images/common/user_default.png'
                uploadSuccess={this._onUploadSuccess.bind(this)}
                uploadError={this._onUploadError.bind(this)}
                onDeleteClick={this._onUploadDelete.bind(this)}
                iconDelete='profile-upload-delete'
                iconUpload='profile-upload'
              />
            </div>
          </div>
          <div className='col colright'>
            <div className='detailblock'>
              <div className='formrow'>
                <div className='formcol'>
                  <Input
                    type='text'
                    name='firstName'
                    label='user.profile.firstNamePlaceholder'
                    value={user.firstName}
                    size={30}
                    maxLength={100}
                    onChange={this._onChangeInput.bind(this, 'firstName')}
                    ref={this._references.inputFirstName}
                    validations={['required']}
                  />
                </div>
              </div>
              <div className='formrow'>
                <div className='formcol'>
                  <Input
                    type='text'
                    name='lastName'
                    label='user.profile.lastNamePlaceholder'
                    value={user.lastName}
                    size={30}
                    maxLength={100}
                    onChange={this._onChangeInput.bind(this, 'lastName')}
                    ref={this._references.inputLastName}
                    validations={['required']}
                  />
                </div>
              </div>
              <div className='formrow'>
                <div className='formcol'>
                  <Input
                    type='text'
                    name='email'
                    label='user.profile.emailPlaceholder'
                    value={user.email}
                    size={30}
                    maxLength={100}
                    onChange={this._onChangeInput.bind(this, 'email')}
                    disabled
                    validations={['required', 'email']}
                  />
                </div>
              </div>
              {this.props.showLanguageDropdown && (
                <div className='formrow'>
                  <div className='formcol'>
                    <Select
                      options={this.data.languages}
                      name='language'
                      multilingualOptions
                      label='user.profile.languagePlaceholder'
                      className='form-dropdown'
                      onChange={this._onChangeInput.bind(this, 'language')}
                      value={user.language}
                    />
                  </div>
                </div>
              )}
              <div className='formrow'>
                <div className='formcol'>
                  <Select
                    options={DateUtil.getTimezoneOptions()}
                    name='timezone'
                    multilingualOptions={false}
                    label='user.profile.timezonePlaceholder'
                    className='form-dropdown'
                    onChange={this._onChangeInput.bind(this, 'timezone')}
                    value={user.timezone}
                  />
                </div>
              </div>
              <span className='change-button'>
                <Button
                  type='button'
                  className='button_user'
                  title='user.profile.actionChangePassword'
                  onClick={this.props.onClickChangePassword}
                />
              </span>
              <IconButton
                icon='common-success-tick'
                title='user.profile.tipSave'
                type='primary'
                className='wizard-submit'
                size='big'
                canHover={false}
                onClick={this._onFormSubmit.bind(this)}
              />
            </div>
          </div>
        </div>
      </form>
    )
  }

  /* Event handlers */
  _onChangeInput (name, value) {
    this.data.user[name] = value
    this.setState({ dataDate: new Date() })
  }

  _onUploadSuccess (file, message) {
    this.setState({
      imageAvatar: message.id,
      imageAvatarUrl: message.url,
      imageDeleted: false
    })
  }

  _onUploadError (_file, _message) {
    this.props.onError('common.form.uploadError')
  }

  _onUploadDelete () {
    if (this.state.imageAvatar) {
      this.setState({
        imageAvatar: null,
        imageAvatarUrl: null,
        imageDeleted: false
      })
    } else {
      this.data.user.image = ''
      this.data.user.imageUrl = ''
      this.setState({ dataDate: new Date(), imageDeleted: true })
    }
  }

  /* Private Function */
  _onFormSubmit (ev) {
    ev.preventDefault()

    let noErrors = 0
    let field = ''
    if (
      this._references.inputFirstName.current &&
      !this._references.inputFirstName.current.validate()
    ) {
      noErrors++
      field = 'user.profile.msgFirstNameError'
    } else if (
      this._references.inputLastName.current &&
      !this._references.inputLastName.current.validate()
    ) {
      noErrors++
      field = 'user.profile.msgLastNameError'
    }

    if (noErrors === 0) {
      if (this.props.onSubmit) {
        this.props.onSubmit(
          this.data.user,
          this.state.imageAvatar,
          this.state.imageDeleted
        )
      }
    } else if (this.props.onError) {
      this.props.onError(field)
    }
  }
}

export default UserProfileForm
